<template>
    <div id="app">
        <router-view/>
    </div>
</template>

<script>
export default {
    name: "EmptyApp",
    mounted() {
        //store current user
        this.$store.dispatch('userStore/getCurrentUser');
    }
}
</script>

<style scoped>

</style>
